import { render, staticRenderFns } from "./wdsc.vue?vue&type=template&id=b9630802&"
import script from "./wdsc.vue?vue&type=script&lang=js&"
export * from "./wdsc.vue?vue&type=script&lang=js&"
import style0 from "./wdsc.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports